<!-- Main menu -->
<div class="navbar-container main-menu-content" style="padding: 0 2.2rem;">
  <ul class="nav navbar-nav" id="main-menu-navigation" layout="horizontal" core-menu></ul>
</div>
<!--/ Main menu -->
